const Styles = {
    'PopoverContainer': 'Popover_PopoverContainer--d7cac1a5',
    'Popover': 'Popover_Popover--2700cc4a',
    'disableTopLeft': 'Popover_disableTopLeft--6d85f6d7',
    'disableTopRight': 'Popover_disableTopRight--eba6dd78',
    'disableBottomRight': 'Popover_disableBottomRight--b783a710',
    'disableBottomLeft': 'Popover_disableBottomLeft--734dbbe4',
    'arrow': 'Popover_arrow--5a0e9001',
    'directionUp': 'Popover_directionUp--d9393dc1',
    'directionRight': 'Popover_directionRight--1704fa3d',
    'directionDown': 'Popover_directionDown--ea9925e4',
    'directionLeft': 'Popover_directionLeft--64e43774',
    'inner': 'Popover_inner--065668b9'
};

export default Styles;